<template>
    <div class="pagosTable" style="width: 100%;">
        <vs-table class="pagosTable" >
            <template #thead>
            <vs-tr>
                <vs-th>
                    <modal-cancelar-pago v-if="(permisos.includes('desaplicar-beca') && permisos.includes('cancelar-descuento') || permisos.includes('cancelar-pago'))" v-model="activeCancelacionPago" :row="selectedInfo" @refreshTable="refreshTable" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" ></modal-cancelar-pago>
                    <modal-devolucion v-if="permisos.includes('devolucion-pagos')" v-model="activeDevolucion" :row="selectedInfo" @refreshTable="refreshTable" :persona-id="personaId" :ciclo-escolar="cicloEscolar" :institucion="institucion" ></modal-devolucion>
                    <!-- <modal-desaplicar-beca v-if="permisos.includes('desaplicar-beca')" v-model="activeDesaplicarBeca" :row="selectedInfo" @refreshTable="refreshTable" ></modal-desaplicar-beca> -->

                </vs-th>
                <vs-th width="125px">
                Concepto
                </vs-th>
                <vs-th width="150px">
                    <vs-button
                        primary
                        border
                        @click="facturarPagos"
                        v-if="permisos.includes('facturar') && selectedRow.length"
                    >
                    Facturar seleccionados
                    </vs-button>
                </vs-th>
                <vs-th width="70px">
                    Monto
                </vs-th>
                <vs-th width="70px">
                    Estatus Saldo
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
                <vs-tr
                    :key="tr.id"
                    v-for="(tr) in listPagos"
                    :data="tr"
                    
                >
                    <vs-td width="10%">           
                        <vs-avatar v-if="tr.mostrar_log !== true" circle :color="categoriasColores && categoriasColores[tr.categoria] && categoriasColores[tr.categoria]['color'] ? categoriasColores[tr.categoria]['color'] : '#6c757db0' ">
                            <template #text>
                                {{ categoriasColores[tr.categoria]['abv'] }}
                            </template>
                        </vs-avatar>
                        <vs-tooltip v-else shadow interactivity>                  
                            <vs-avatar badge-position="top-right" badge-color="danger" circle :color="categoriasColores && categoriasColores[tr.categoria] && categoriasColores[tr.categoria]['color'] ? categoriasColores[tr.categoria]['color'] : '#6c757db0' ">
                                <template #text>
                                    {{ categoriasColores[tr.categoria]['abv'] }}
                                </template>
                                <template #badge>
                                    <i class="fas fa-exclamation"></i>
                                </template>
                            </vs-avatar>
                            <template #tooltip>
                            <div class="content-tooltip">
                                <div class="body">
                                    <div class="text">
                                        <p class="mb-0"><span v-if="tr && tr.usuario && tr.usuario.nombre">Creado por: <strong>{{tr.usuario.nombre}}</strong>  el día</span><span v-if="tr && tr.usuario && !tr.usuario.nombre">Fecha de creación</span> <span v-if="tr && tr.usuario && tr.usuario.fecha_creacion"> <strong>{{tr.usuario.fecha_creacion}}</strong></span></p>
                                        <p class="mb-0" v-if="tr && tr.usuario && tr.usuario.fecha_actualizacion">Fecha de modificación: <strong>{{tr.usuario.fecha_actualizacion}}</strong></p>
                                        <md-divider v-if="tr && tr.factura && tr.factura.usuario" class="my-2"></md-divider>
                                        <p class="mb-0" v-if="tr && tr.factura && tr.factura.usuario && tr.factura.usuario.nombre && (tr.factura.usuario.nombre !== tr.usuario.nombre)">Factura creada por: <strong>{{tr.factura.usuario.nombre}}</strong></p>
                                        <p class="mb-0" v-if="tr && tr.factura && tr.factura.usuario && tr.factura.usuario.fecha_creacion">Fecha de factura creada: <strong>{{tr.factura.usuario.fecha_creacion}}</strong></p>
                                        <div v-for="(cancelado,i) in tr.factura.cancelados" :key="i">
                                            <p class="mb-0" v-if="cancelado.usuario.nombre">Factura cancelada por: <strong>{{cancelado.usuario.nombre}}</strong></p>
                                            <p class="mb-0" v-if="cancelado.usuario.fecha_actualizacion">Fecha de factura cancelada: <strong>{{cancelado.usuario.fecha_actualizacion}}</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </template>  
                        </vs-tooltip>
                    </vs-td>
                    <vs-td>
                        <h6> {{ tr.concepto ? tr.concepto : '' | uppercase }}</h6>
                        <p class="m-0 mb-1"> {{ tr.fuente ? tr.fuente : '' }}</p>
                        <div class="mt-2 pt-2" v-if="tr.subcategoria_servicio != ''" style="border-top: 1px solid #A9CCE3;margin: 4px 0">
                            <p class="mb-0">Subcategoría</p>
                            <h6 >{{ tr.subcategoria_servicio }}</h6>
                        </div>
                        <!-- MENU  -->
                        <!-- <md-menu md-align-trigger v-if="tr.comentarios !== 'Pago cancelado' && tr.fuente !== 'Devolucion de pago'">
                            <md-button v-if="(permisos.includes('desaplicar-beca')  || permisos.includes('cancelar-descuento') || permisos.includes('cancelar-pago')) && tr.comentarios !== 'Descuento cancelado'" md-menu-trigger><span style="font-size: 12px;">Acciones <md-icon  style="font-size: 14px !important;"></md-icon></span></md-button>
                            <md-menu-content>
                                <md-menu-item v-if="permisos.includes('desaplicar-beca') && tr.categoria === 'beca' && tr.comentarios !== 'BECA_INACTIVA' " @click="activeCancelacionPago = ! activeCancelacionPago; selectedInfo = tr;" v-show="tr.factura.facturado !== 'timbrado'">Desaplicar beca</md-menu-item>
                                <md-menu-item v-if="permisos.includes('devolucion-pagos') && tr.categoria !== 'rebaja'" @click="activeDevolucion = ! activeDevolucion; selectedInfo = tr;">Devolución</md-menu-item>

                                <md-menu-item v-show="tr.factura.facturado !== 'timbrado'" v-if="permisos.includes('cancelar-pago') && tr.fuente !== 'Descuentos' && tr.categoria !== 'beca' && tr.categoria !== 'rebaja' && tr.factura.facturado !== 'timbrado'" @click="activeCancelacionPago = !activeCancelacionPago; selectedInfo = tr;"><span style="font-size: 14px;">Cancelar pago</span></md-menu-item>

                                <md-menu-item v-show="tr.factura.facturado !== 'timbrado'" v-if="permisos.includes('cancelar-descuento') && tr.categoria === 'rebaja' || tr.fuente == 'Descuentos'" @click="activeCancelacionPago = !activeCancelacionPago;  selectedInfo = tr;"><span style="font-size: 14px;">Cancelar descuento</span></md-menu-item>
                            </md-menu-content>
                        </md-menu> -->
                    </vs-td>
                    <vs-td>
                        <!-- <div v-if="tr.cancelado === true">
                            <md-chip :class="'mini-chip ' + getColorStatusPago(getStatusPago(tr))" ><strong>{{ getStatusPago(tr) }}</strong></md-chip>
                        </div> -->
                        <div v-if="tr.categoria != 'rebaja' && tr.fuente != 'Descuentos' && tr.fuente != 'Devolucion de pago' ">
                            <md-chip v-if="tr && getFacturaValue(tr) == 'Facturado'" class="mb-1 fontMedium" :class="'mini-chip ' + getFacturaColor(getFacturaValue(tr))" ><strong> {{ getFacturaValue(tr) }} </strong></md-chip>
                            <p class="salto mb-1"><strong>No. autorización: </strong> {{ tr.autorizacion_pago }}</p>
                            <p class="salto mb-1"><strong>{{ tr.factura && tr.factura.uuid && tr.factura.metodo_pago ? tr.factura.metodo_pago : tr.metodo_pago ? tr.metodo_pago : 'Método de pago no definido'}}</strong> </p>
                            <p class="salto mb-1" v-if="tr.factura && tr.factura.uuid"><strong>UUID:</strong> <i class="fas fa-barcode"></i> {{ tr.factura && tr.factura.uuid ? tr.factura.uuid : 'UUID No definido'}}</p>
                            <p class="salto mb-1"><strong> F.Pago:</strong> <i class="far fa-calendar-check"></i> {{ tr && tr.fecha_pago && tr.fecha_pago > '0000-00-00' ? tr.fecha_pago : 'F. Pago no definido'}}</p>
                            <p class="salto mb-1"  v-if="tr.factura && tr.factura.fecha_factura"><strong>F.Factura:</strong> <i class="far fa-calendar"></i> {{ tr.factura && tr.factura.fecha_factura ? getFechaTimbrado(tr.factura.fecha_factura) : 'Factura No definido'}}</p>
                            <vs-checkbox 
                            v-if="(permisos.includes('facturar')) && tr.fuente !='Cancelacion de pagos' &&  tr.fuente !='Cancelacion de beca' &&  tr.fuente !='Cancelación de descuentos' && tr.fuente !='Saldos iniciales' && tr.comentarios != 'BECA_INACTIVA'  && ((tr.factura && !tr.factura.uuid && tr.monto > 0 ) || !tr.factura || tr.factura.facturado != 'timbrado') && tr.comentarios != 'Pago cancelado'"
                            class="rounded-check checkFactura" 
                            v-model="selectedRow"                                                                                                   
                            :val="tr.id"
                            > 
                            <p class="mb-0"> 
                                <strong> Facturar </strong> 
                            </p>
                            </vs-checkbox>
                            <small class="md-chip  mb-1 mini-chip col-red" v-if="tr.factura && tr.factura.cancelados && Array.isArray(tr.factura.cancelados) && tr.factura.cancelados.length" > UUID cancelados: </small>
                            <small :key="i"
                                v-for="(tr, i) in tr.factura.cancelados"
                                :data="tr"
                                :v-if="tr"
                                :class=" tr ? 'md-chip  md-theme-default mb-1 mini-chip col-red': ''" 
                            > {{tr.uuid}}
                            </small>
                            <div style="display: flex">
                                <div style="width:33%;">
                                    <vs-tooltip>
                                        <vs-button v-if="tr.factura && tr.factura.uuid && tr.factura.facturado !== 'cancelado'"
                                            class="ml-auto mr-auto"
                                            icon
                                            color="success"
                                            flat
                                            @click="getFactura(tr.id ? tr.id : '', tr.factura.uuid ? tr.factura.uuid : '')"
                                            
                                        >
                                            <i class="far fa-file-pdf fa-xs mini-icon mr-1"></i> PDF
                                        </vs-button>
                                        <template #tooltip>
                                            Descargar factura PDF
                                        </template>
                                    </vs-tooltip>
                                </div>
                                <div style="width:33%;">
                                    <vs-tooltip>
                                        <vs-button v-if="tr.factura && tr.factura.uuid && tr.factura.facturado !== 'cancelado'"
                                            class="ml-auto mr-auto"
                                            icon
                                            color="primary"
                                            flat
                                            @click="downloadXML(tr.id ? tr.id : '', tr.factura.uuid ? tr.factura.uuid : '')"
                                            
                                        >
                                            <i class="fas fa-file-download fa-xs mini-icon mr-1"></i> XML
                                        </vs-button>
                                        <template #tooltip>
                                            Descargar factura XML
                                        </template>
                                    </vs-tooltip>
                                </div>
                                <div style="width:33%;" v-if="tr.factura && tr.factura.status !== 'en_proceso_de_cancelacion' || tr.factura && tr.factura.status !== 'cancelado'">
                                    <vs-button v-if="(tr.factura && tr.factura.uuid && tr.factura.facturado !== 'cancelado') && tr.factura.tipo_facturacion == 'generica' && permisosFamiliar.includes('padres-puedan-cancelar-facturas')"
                                        class="ml-auto mr-auto"
                                        icon
                                        color="danger"
                                        flat
                                        @click="activeCancelarFactura =! activeCancelarFactura, row = tr"
                                    >
                                        Cancelar factura
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                                <p v-if="tr.fuente !== 'Devolucion de pago'">N/A</p>
                                <md-chip v-else :class="'mini-chip '" class="col-purple"><strong>Devolución</strong></md-chip>
                        </div>
                    
                    </vs-td>
                    <vs-td>
                        <span class="fontBig"><strong>{{ tr.monto ? tr.monto : '' | currency }}</strong></span>
                    </vs-td>
                    <vs-td>
                        <md-chip v-if="(tr && tr.saldo || tr.saldo == 0) && tr.fuente !== 'Devolucion de pago'" :class="'mini-chip ' + getColorStatusPago(getStatusPago(tr))" ><strong>{{ getStatusPago(tr) }}</strong></md-chip>
                        <md-chip v-else :class="'mini-chip '" class="col-purple"><strong>Devolución</strong></md-chip>
                        <!-- <div v-if="trimValue(tr.comentarios) === 'Pago cancelado'">
                            <md-chip v-if="tr" class="mb-1 fontMedium" :class="'mini-chip ' + getFacturaColor(getFacturaValue(tr))" ><strong> Pago cancelado </strong></md-chip>
                        </div> -->
                        <p class="salto mb-0"></p>
                        <p class="salto mb-0" v-if="tr.saldo > 0 ">Saldo disponible</p>
                        <p class="salto mb-0 fontBig" v-if="tr.saldo > 0 ">{{ tr.saldo && tr.saldo > 0 ? tr.saldo : 0 | currency}}</p>
                            
                    </vs-td>
                </vs-tr>
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
            <template #notFound>
                No hay registros
            </template>
        </vs-table>
        <modal-cancelar-factura v-model="activeCancelarFactura" :row="row"></modal-cancelar-factura>
    </div>
</template>


<script>
import cobranza from '../../../api/requests/cobranza-persona'
import ModalCancelarPago from './modales/cancelar-pago'
import ModalDevolucion from './modales/devolucion'
import ModalDesaplicarBeca from './modales/desaplicar-beca'
import ModalCancelarFactura from './modales/cancelar-factura-solo.vue'
export default {
    props:[
        'personaId',
        'cicloEscolar',
        'institucion',
        'permisos',
        'personaRol',
        'permisosFamiliar'
    ],
    data () {
        return {
            categoriasColores: {
                "inscripcion" : {
                    "color" : "#55ce63",
                    "abv" : "I"
                },
                "colegiatura" : {
                    "color" : "#009efb",
                    "abv" : "C"
                },
                "beca" : {
                    "color" : "#54667a",
                    "abv" : "B"
                }, 
                "rebaja" : {
                    "color" : "#54667a",
                    "abv" : "D"
                },
                "servicio" : {
                    "color" : "#7460ee",
                    "abv" : "S"
                },
            },
            facturadosColores: {
                "Facturado" : "green",
                "Cancelado" : "red",
                "Sin factura" : "red"
            },
            statusPagoColores: {
                "Aplicado" : "green",
                "Por aplicar" : "red",
                "Aplicado parcialmente": "yellow",
                "Cancelado": "red",
            },
            selectedRow: [],
            selectedInfo: [],
            oldIds:[],
            oldDetail:{},
            page: 1, 
            max: 10,
            pages: 0, 
            listPagos: [],
            value: '',
            row: [],
            activeCancelarFactura: false,
            activeCancelacionPago: false,
            activeCancelacionDescuento: false,
            facturaCancelada: {},
            activeDesaplicarBeca: false, 
            activeDevolucion: false,
        }
    },
    methods : {
        // trimValue(val){
        //     if (val){
        //         return val.trim()
        //     }
        //     return val
        // },
        getFechaTimbrado(fecha_timbrado){
            const fechaActual = new Date(fecha_timbrado)
            const ahora = fechaActual.toLocaleString()
            return ahora
        },
        refreshTable (){
            this.$emit('refreshTable')
        },
        async getPagos() {
            if (this.personaId){
                try {
                    let params = {
                        page: this.page || 1,
                        size: this.max || 20,
                        id: this.personaId,
                        institucion: this.institucion,
                        ciclo_escolar: this.cicloEscolar
                    }
                    const { data: response = null } = await cobranza.getPagosPersona(params) || {}
                    const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                    this.pages = Math.ceil(total/per_page) || 0
                    this.listPagos = dataTable
                } catch (error) {
                    this.listPagos = []
                    this.pages = 1
                }
            }
        },
        async facturarPagos () {
            try {
                    const vm = this
                    if (this.selectedRow.length){                      
                        this.$emit('loading')
                        try {
                            let params = {
                                id: this.personaId,
                                ciclo_escolar: this.cicloEscolar,
                                institucion: this.institucion,
                                pagos :  vm.selectedRow
                            }
                            const { data: response = null } = 
                            await cobranza.postFacturar(params) 
                            // { data: { uuids: ['1','2','3'] } }
                            || {}
                            this.$emit('endLoading')
                            if (response && response.mensaje_exitoso ){
                                this.$vs.notification({
                                    progress: 'auto',                           
                                    color: 'success',
                                    position: null,
                                    title: 'UUID facturado',
                                    duration: '10000',
                                    text: response.mensaje_exitoso
                                })                                

                                this.listPagos = []
                                vm.selectedRow = []
                                this.getPagos()
                            }else {
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    duration: '10000',
                                    text: response.mensaje_error
                                })
                            }
                        } catch (error) {
                            this.$emit('endLoading')
                             if (error.response && error.response.data){
                                const data = error.response.data
                                if (data.descripcion){
                                    this.$vs.notification({
                                        progress: 'auto',
                                        color: 'danger',
                                        position: null,
                                        title: 'Error',
                                        duration: '10000',
                                        text: data.descripcion
                                    })
                                }
                            }else{
                                this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Error',
                                duration: '10000',
                                text: `Algo salió mal`
                                })
                            }
                        }
                       
                       
                    }else{
                          this.$vs.notification({
                            progress: 'auto',
                            color: 'warning',
                            position: null,
                            title: 'Advertencia',
                            text: 'No hay pagos seleccionados'
                        })
                    }
            } catch (error) {
            }
        },
        getFacturaValue(value){
            return value.factura && value.factura.fecha_factura && value.factura.facturado == 'timbrado' ? 'Facturado' : ''
            // return value.factura && value.factura.fecha_factura && value.factura.facturado == 'timbrado' ? 'Facturado' : value.factura.facturado == 'cancelado' ? 'Cancelado' : value.categoria != 'rebaja' ? 'Sin factura' : 'N/A'
        },
        getFacturaColor(val){
            let classes = ''
            if (
                val 
                && this.facturadosColores[val] 
            ) {
                classes = 'col-'+this.facturadosColores[val]
            }
            return classes
        },
        async getFactura(m, uuid){
            try {
                if (this.personaId){
                    const response = await cobranza.getFacturaTemp(this.personaId , m, uuid)
                    this.dowloadFile(response.data, response.headers)
                }
            } catch (error) {
                if (error.response.data && error.response.data.errors){
                                const data = error.response.data.errors
                                data.forEach(element => {
                                    this.$vs.notification({
                                        progress: 'auto',
                                        color: 'danger',
                                        position: null,
                                        title: 'Error',
                                        text: element
                                    })
                                });

                            }else{
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: `Algo salió mal`
                                })
                            }
            }
           
           
        },
        async downloadXML(m, uuid){
            try {
                if (this.personaId){
                    const response = await cobranza.downloadXML(this.personaId , m, uuid)
                    this.dowloadFile(response.data, response.headers)
                }
            } catch (error) {
                if (error.response.data && error.response.data.errors){
                                const data = error.response.data.errors
                                data.forEach(element => {
                                    this.$vs.notification({
                                        progress: 'auto',
                                        color: 'danger',
                                        position: null,
                                        title: 'Error',
                                        text: element
                                    })
                                });

                            }else{
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: `Algo salió mal`
                                })
                            }
            }
        },
        getStatusPago({saldo, monto, cancelado, factura}){
            if (saldo === 0 && cancelado !== true){
                return 'Aplicado'
            }else if(cancelado === true){
                return 'Cancelado'
            }else if (saldo > 0 && saldo === monto) {
                return 'Por aplicar'
            } else if (saldo > 0) {
                return 'Aplicado parcialmente'
            } else if (cancelado == true) {
                return 'Cancelado'
            }

            return null
        },
        getColorStatusPago(statusPago){
            if (statusPago && this.statusPagoColores[statusPago]){
                return `col-${this.statusPagoColores[statusPago]}`
            }else {
                return 'col-none'
            }
        },
        dowloadFile(blob, headers){
            if (blob instanceof Blob) {
                const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                var filename = "";
                const disposition = headers['content-disposition'];
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                        link.setAttribute('download', filename)
                    }
                }
                document.body.appendChild(link);
                link.click();
                link.remove();
            }else{
                throw { message: 'formatError' }
            }
        }
    },
    computed: {
        
    },
    components : {
        ModalCancelarPago,
        ModalDevolucion,
        ModalCancelarFactura
        // ModalDesaplicarBeca

    },
    watch:{
        page () {
            this.getPagos()
        },
        selectedRow (val) {
            if (val){
                this.$emit('input', val);
            }
        }   
    }
}
</script>

<style>
.pagosTable .vs-table__footer {
    padding: 0;
}
</style>

<style lang="scss" scoped >
.salto {
    display: block;
}

.mini-icon {
     font-size: 0.7rem !important;
}

@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }


.vs-button--border:focus {
    /* color: #009efb; */
    background: rgba(var(--vs-color), 1);
}

table {
    border-collapse:collapse
}

.hoverLine :hover{
    border-left: 1px solid red;
}

.fontBig{
    font-size: 16px;
}

.fontMedium{
    font-size: 15px;
}

.fontSmall{
    font-size: 12px;
}

</style>

<style>

.checkFactura .vs-checkbox-label {
    margin-bottom: 0;
}
</style>